import React, { useEffect, useState } from "react";
import getCondominioData from "../../../../API/server/getCondominios";
import sendChamados from "../../../../API/server/sendChamados";
import atualizarCache from "../../../../API/server/updateChamadoCache";
import "./acao.css";

const Acao = ({ onClose, updateRegistros, fecharPai,chamadoDetalhes}) => {
    const [condominioData, setCondominioData] = useState(null);
    const [expanded, setExpanded] = useState({});
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [error, setError] = useState(null);
    const [actionResult, setActionResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // Estado para controle do carregamento
    const user = JSON.parse(sessionStorage.getItem("user"));

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getCondominioData();
                setCondominioData(data.condominio);
            } catch (err) {
                setError(err.message);
            }
        };

        fetchData();
    }, []);

    const handleToggleExpand = (key) => {
        setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleCheckboxChange = (key, contactType) => {
        const contact = `${key}-${contactType}`;
        setSelectedContacts((prev) => {
            if (prev.includes(contact)) {
                return prev.filter((item) => item !== contact);
            } else {
                return [...prev, contact];
            }
        });
    };

    const handleSendChamados = async () => {
        setIsLoading(true);
        try {
            const titulo = "Relatório de Contatos Selecionados";
    
            if (!condominioData) {
                throw new Error("Dados do condomínio não estão disponíveis.");
            }
    
            // Mapeia e valida os contatos selecionados
            const validContacts = selectedContacts
                .map((contact) => {
                    const [key, contactType] = contact.split("-");
                    const responsavel = condominioData[key]?.responsavel?.nome || "Não identificado";
                    const value = condominioData[key]?.contato?.[contactType];
                    return {
                        responsavel,
                        type: contactType,
                        key,
                        value,
                    };
                })
                .filter((contact) => contact.value && contact.value.trim() !== "");
    
            if (validContacts.length === 0) {
                throw new Error("Nenhum contato válido foi selecionado.");
            }
    
            const chamadoData = {
                titulo,
                contacts: validContacts,
                timestamp: new Date().toISOString(),
                user,
                chamadoDetalhes: chamadoDetalhes.chamado,
            };
    
            const response = await sendChamados(chamadoData);
    
            if (response) {
                setActionResult("Chamados enviados com sucesso, aguarde um momento...");
    
                // Aguarda a atualização do cache antes de fechar o modal
                await atualizarCache();
    
                // Após a atualização do cache, fecha o modal e atualiza os registros
                onClose();
                updateRegistros();
                fecharPai();
            } else {
                throw new Error("Erro desconhecido ao enviar chamados.");
            }
        } catch (err) {
            console.error("Erro ao enviar chamados:", err);
            setActionResult(`Erro ao enviar chamados: ${err.message}`);
        } finally {
            setIsLoading(false);
        }
    };
    
    
    if (!user || !user.report) {
        return <div>Dados insuficientes para exibir o relatório.</div>;
    }

    const report = Object.entries(user.report).filter(([key, value]) => value === true);

    const sortedKeys = ["administrador", "sindico", "construtora", "fornecedor"];


    if (error) {
        return <div>Erro ao carregar dados: {error}</div>;
    }

    return (
        <div className="acaoContent">
            <div className="headerAcao">
                <h1>Reportar para quem?</h1>
            </div>
            <div className="bodyAcao">
                {condominioData &&
                    sortedKeys.map((sortedKey, index) => {
                        const contactData = condominioData[sortedKey]?.contato;
                        const responsavelNome = condominioData[sortedKey]?.responsavel?.nome || "Não identificado"; // Nome do responsável
                        if (report.some(([key]) => key.toLowerCase() === sortedKey) && contactData) {
                            return (
                                <div key={index} className="reportContainer">
                                    <button
                                        className="btnReport"
                                        onClick={() => handleToggleExpand(sortedKey.toUpperCase())}
                                    >
                                        {`${sortedKey.toUpperCase()} - ${responsavelNome}`}
                                    </button>
                                    {expanded[sortedKey.toUpperCase()] && (
                                        <div className="reportDetails">
                                            {["email", "telefone", "whatsapp"].some(
                                                (contactType) => contactData[contactType]
                                            ) ? (
                                                ["email", "telefone", "whatsapp"].map(
                                                    (contactType) =>
                                                        contactData[contactType] && (
                                                            <div key={contactType} className="checkboxContainer">
                                                                <label>
                                                                    <input
                                                                        id="checkboxAcao"
                                                                        type="checkbox"
                                                                        onChange={() =>
                                                                            handleCheckboxChange(sortedKey, contactType)
                                                                        }
                                                                        checked={selectedContacts.includes(
                                                                            `${sortedKey}-${contactType}`
                                                                        )}
                                                                    />
                                                                    <b>
                                                                        {contactType.charAt(0).toUpperCase() +
                                                                            contactType.slice(1)}
                                                                        :
                                                                    </b>{" "}
                                                                    {contactData[contactType]}
                                                                </label>
                                                            </div>
                                                        )
                                                )
                                            ) : (
                                                <p>Sem dados cadastrados</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                        return null;
                    })}
            </div>
            <div className="acaoBtnCampo">
                {isLoading ? (
                    <div className="loading">Carregando...</div>
                ) : (
                    <>
                        <button
                            id="btnAcao-acao"
                            className="btnAcao"
                            onClick={handleSendChamados}
                        >
                            Realizar ação
                        </button>
                        <button id="btnAcao-voltar" className="btnAcao" onClick={onClose}>
                            Deixar para depois
                        </button>
                    </>
                )}
            </div>
            {actionResult && (
                <div className="resultMessage">
                    <p>{actionResult}</p>
                </div>
            )}
        </div>

    );
    
};

export default Acao;
